import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { DollarOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Sales = () => (
  <div>
    <Title level={3}>Ventas</Title>
    <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
      <Empty
        image={<DollarOutlined style={{ fontSize: 64, color: '#E8192C' }} />}
        description={
          <div>
            <Title level={4} style={{ marginTop: 16 }}>Reporte de Ventas</Title>
            <Paragraph type="secondary">
              Consolidado de ventas: El Camello, PUNTO+ (8 tiendas), distribuidoras y Monarca.
            </Paragraph>
            <Paragraph type="secondary">Disponible en Fase 5</Paragraph>
          </div>
        }
      />
    </Card>
  </div>
);

export default Sales;
